import { render, staticRenderFns } from "./Coberturas.vue?vue&type=template&id=1f7ba0e6&scoped=true"
import script from "./Coberturas.vue?vue&type=script&lang=js"
export * from "./Coberturas.vue?vue&type=script&lang=js"
import style0 from "./Coberturas.vue?vue&type=style&index=0&id=1f7ba0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ba0e6",
  null
  
)

export default component.exports